import { useMutation, useQuery } from 'react-query';
import { letters } from '../../../../API/TT_ELD/mobile/malfunction';

interface LettersParams {
  page?: number | string;
  perPage?: number | string;
  startDate?: string;
  endDate?: string;
  companyId?: number | string;
  driverId?: number | string;
  creatorId?: number | string;
}

export const useLetters = (params: LettersParams): object => {
  return useQuery(
    [
      'letters/list',
      params?.page,
      params?.perPage,
      params?.startDate,
      params?.endDate,
      params?.companyId,
      params?.driverId,
      params?.creatorId,
    ],
    () => letters.read(params),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );
};

export function useCreateLetter() {
  return useMutation(
    (payload: { startDate: string; endDate: string; driverId: number | string; note?: string }) =>
      letters.create(payload),
  );
}
